@if (content) {
  <div class="w-12 flex flex-column flex-middle p-t-8 p-b-10 p-t-4-m p-t-4-s p-b-6-m p-b-6-s"
    [ngClass]="styleVariant === 'default' && 'bg-col-5'">
    <div class="ratio-1-1 p-a"
      [ngClass]="styleVariant === 'default' ? 'w-3 w-6-m w-6-s' : 'w-5 w-6-m w-6-s'">
      <img class="fill"
        [image]="content.image">
    </div>
    <p [ngClass]="titleClass"
      class="center"
    *iCms="'title' of content"></p>
    @if (!((client.isM || client.isS) && styleVariant === 'default')) {
      <p class="p1 col-11 center"
        [ngClass]="styleVariant === 'default' && 'm-t-3'"
      *iCms="'subtitle' of content"></p>
    }
    @if (styleVariant === 'modal') {
      <p class="p2 m-t-2 col-12 center"
      *iCms="'copy' of content"></p>
    }
  </div>
}
